import type { TermsAcceptanceKind, TermsAudience } from '@/shared/api/resources';

/** Permissoes do modulo (P-USU-2). Quem decide e o servidor; a tela so reflete. */
export const PERMISSAO_VER_TERMO = 'termos.termo.view';
export const PERMISSAO_EDITAR_TERMO = 'termos.termo.update';
export const PERMISSAO_APROVAR_TERMO = 'termos.termo.approve';
export const PERMISSAO_VER_ACEITES = 'termos.aceite.view';

/** Tipos do termo de aceite da proposta, na ordem da tela. */
export const TIPOS_DE_TERMO_DE_ACEITE: TermsAcceptanceKind[] = [
  'emissao',
  'endosso',
  'cotacao',
];

/** Onde o termo de aceite aparece no OnPoint. */
export const ROTULO_DO_TIPO: Record<TermsAcceptanceKind, string> = {
  emissao: 'Emissao da apolice',
  endosso: 'Solicitacao de endosso',
  cotacao: 'Nova cotacao da corretora',
};

export const ROTULO_DO_PUBLICO: Record<TermsAudience, string> = {
  corretora: 'Pessoas das corretoras',
  todos: 'Todas as pessoas da empresa',
};
